// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___P0JOR","suggestionPanel":"styles-module__suggestionPanel___2WuLm"};